<script setup lang="ts">
import { CheckCircle2, Info, TriangleAlert, XCircle, X } from 'lucide-vue-next';
import { useToastStore } from '@/stores/toast';

const toast = useToastStore();
const icons = { success: CheckCircle2, error: XCircle, info: Info, warning: TriangleAlert };
const colors = { success: 'text-leaf-600', error: 'text-red-600', info: 'text-navy-500', warning: 'text-sun-500' };
</script>

<template>
  <div class="pointer-events-none fixed inset-x-0 bottom-0 z-[60] flex flex-col items-center gap-2 p-4 sm:bottom-auto sm:right-0 sm:top-0 sm:left-auto sm:items-end" aria-live="polite">
    <TransitionGroup enter-from-class="translate-y-2 opacity-0" leave-to-class="opacity-0" enter-active-class="transition" leave-active-class="transition">
      <div v-for="t in toast.toasts" :key="t.id" class="card pointer-events-auto flex w-full max-w-sm items-start gap-3 p-3 shadow-pop" role="status">
        <component :is="icons[t.kind]" class="mt-0.5 h-5 w-5 shrink-0" :class="colors[t.kind]" />
        <div class="min-w-0 flex-1">
          <p class="text-sm font-medium">{{ t.title }}</p>
          <p v-if="t.message" class="mt-0.5 text-xs text-muted">{{ t.message }}</p>
        </div>
        <button type="button" class="rounded p-0.5 text-muted hover:text-current" aria-label="Dismiss" @click="toast.dismiss(t.id)">
          <X class="h-4 w-4" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>
